"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var link_1 = require("../../structure/link");
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
}
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragItem = (0, react_1.createRef)();
        _this.dragOverItem = (0, react_1.createRef)();
        _this.dragImg = null;
        _this.handleDragStart = function (event, index) {
            event.dataTransfer.setDragImage(_this.dragImg, 0, 0);
            _this.dragItem.current = index;
        };
        _this.handleDragOver = function (event) {
            event.preventDefault();
        };
        _this.handleDragEnter = function (index) {
            _this.dragOverItem.current = index;
            var copiedTabs = __spreadArray([], _this.props.tabs, true);
            var dragItemContent = copiedTabs[_this.dragItem.current];
            copiedTabs.splice(_this.dragItem.current, 1);
            copiedTabs.splice(_this.dragOverItem.current, 0, dragItemContent);
            _this.dragItem.current = _this.dragOverItem.current;
            if (_this.props.handleChangeTabs)
                _this.props.handleChangeTabs(copiedTabs);
        };
        _this.handleDrop = function () {
            _this.dragItem.current = null;
            _this.dragOverItem.current = null;
            if (_this.props.handleDropEnd)
                _this.props.handleDropEnd();
        };
        return _this;
    }
    Tabs.prototype.componentDidMount = function () {
        this.dragImg = new Image(0, 0);
        this.dragImg.src =
            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    };
    Tabs.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "border-b border-gray-200" },
                react_1.default.createElement("nav", { className: "-mb-px flex space-x-8", "aria-label": "Tabs" }, this.props.tabs.map(function (tab, index) {
                    var containerClassName = classNames(tab.id === _this.props.selectedId
                        ? "border-primary-500 text-primary-600"
                        : _this.dragItem.current === index
                            ? "border-gray-300 text-gray-700"
                            : "border-transparent text-gray-500 ".concat(_this.dragItem.current === null &&
                                "hover:text-gray-700 hover:border-gray-300"), "cursor-pointer whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm");
                    if (_this.props.onClick) {
                        return (react_1.default.createElement("div", { key: tab.name, className: containerClassName, onClick: _this.props.onClick.bind(_this, tab.id), draggable: _this.props.draggable, onDragStart: function (event) { return _this.handleDragStart(event, index); }, onDragEnter: function () { return _this.handleDragEnter(index); }, onDragOver: function (event) { return _this.handleDragOver(event); }, onDrop: _this.handleDrop },
                            react_1.default.createElement("div", { className: "flex flex-cols-2" },
                                tab.name,
                                tab.del)));
                    }
                    else {
                        return (react_1.default.createElement("div", { key: tab.name, draggable: _this.props.draggable, onDragStart: function (event) { return _this.handleDragStart(event, index); }, onDragEnter: function () { return _this.handleDragEnter(index); }, onDragOver: function (event) { return _this.handleDragOver(event); }, onDrop: _this.handleDrop, className: containerClassName },
                            react_1.default.createElement(link_1.Link, { key: tab.name, href: tab.href, linkType: _this.props.linkType, custom: _this.props.custom }, tab.name)));
                    }
                })))));
    };
    return Tabs;
}(react_1.Component));
exports.Tabs = Tabs;
//# sourceMappingURL=index.js.map